export default "__VITE_ASSET__BCLhraLK__"